import { render, staticRenderFns } from "./SlideSede.vue?vue&type=template&id=9c9bed44&scoped=true"
import script from "./SlideSede.vue?vue&type=script&lang=js"
export * from "./SlideSede.vue?vue&type=script&lang=js"
import style0 from "./SlideSede.vue?vue&type=style&index=0&id=9c9bed44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9bed44",
  null
  
)

export default component.exports